import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import ElementWithPopover from '../desktop/components/element-with-popover';
import RoundButton from '../mobile/components/round-button';
import isMobile from '../vendor/detect-mobile';

import '../desktop/css/smart-deadline.css';

class SmartDeadlinePopover extends Component {
  get placement() {
    return 'bottom';
  }

  onShowMobileModal() {
    this.props.showSmartDeadlineModal();
  }

  renderTitle() {
    return (
      <p>
        <strong>
          <FormattedMessage
            id="smartDeadline.title"
            defaultMessage="Smart deadline"
          />
        </strong>
      </p>
    )
  }

  renderPrimaryCopy() {
    const {
      isActive,
      isExpired,
    } = this.props;

    if (isActive && !isExpired) {
      const message = `This {smartDeadline} is calculated as the optimal window for you and other
      group members to join in order to maximize the chance you secure the purchase.`;

      const smartDeadline = (
        <strong>
          <FormattedMessage
            id="smartDeadline.smartDeadline"
            defaultMessage="Smart Deadline"
          />
        </strong>
      );

      return (
        <div>
          <FormattedMessage
            id="smartDeadline.primary.one"
            defaultMessage={message}
            values={{ smartDeadline }}
          />
        </div>
      );
    }
  }

  renderPopover() {
    return (
      <div className="smart-deadline-popover">
        {this.renderTitle()}
        <p>{this.renderPrimaryCopy()}</p>
      </div>
    );
  }

  render() {
    const {
      haveActivePayments,
    } = this.props;

    if (!haveActivePayments) return null;

    if (isMobile) {
      return (
        <RoundButton className="float-right" onClick={() => this.onShowMobileModal()}>
          <FormattedMessage
            id="smartDeadline.mobile.title"
            defaultMessage="Smart deadline"
          />
        </RoundButton>
      )
    }

    return (
      <ElementWithPopover
        name="smart-deadline"
        className="d-inline-block"
        placement={this.placement}
        content={this.renderPopover()}>
        <span className="small-print">
          <i className="fa fa-question round-border small cool-grey" aria-hidden="true" />
        </span>
      </ElementWithPopover>
    );
  }
}

export default SmartDeadlinePopover;



// WEBPACK FOOTER //
// ./src/components/smart-deadline-popover.js